const routes = [
  {
    path: "comentarios",
    component: () => import("@/views/colaborador/comentarios/Comentarios.vue"),
    meta: {
      menu: "dashboard",
      title: "Comentarios",
    },
  },
];

export default routes;
